import React, { Component } from "react";
import SimpleDataTable from "../../../../modules/SimpleDataTable";

class HadiahTab extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, { rowIndex }) => <>{rowIndex + 1}</>,
      },
    },
    {
      name: "kodeHadiah",
      label: "Kode Hadiah",
    },
    {
      name: "namaHadiah",
      label: "Nama Hadiah",
    },
    {
      name: "kategoriHadiah",
      label: "Kategori",
    },
    {
      name: "giftQty",
      label: "Qty",
    },
    {
      name: "qrCodeHadiah",
      label: "QR Code",
    },
  ];

  render() {
    return (
      <SimpleDataTable
        data={this.props.data}
        columns={this.tableColumns}
        rowsPerPage={5}
        options={{ serverSide: false }}
      />
    );
  }
}

export default HadiahTab;
